import React from "react";
import { idTypeActiviteToTypeActivite } from "../../models/interfaces/ITypeActivite";


interface IProps {
  Item?: string;
}

const HtmlRenderTypeActivite: React.FC<IProps> = ({ Item }) => {
  return (
    <span >
      {" "}
      {Item ? idTypeActiviteToTypeActivite(Item) : "Non défini"}
    </span>
  );
};

export default HtmlRenderTypeActivite;
